module.exports = __webpack_public_path__ + "static/404-hero-052dcd2f7bcad9a676386cdbc766ac3e.svg";